/** URL segment for `/chatbot_tag/:tagId` — must stay in sync with tag page resolution. */
export function tagNameToUrlSlug(tagName: string): string {
  return tagName
    .toLowerCase()
    .replace(/\+/g, "-plus")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}
